import { AbsoluteTimeRange } from '@chronosphereio/core';
import { TimeScale, TimeSeriesDataset } from '@/core';
import { TooltipHeader } from '../../TooltipHeader';
import { ShowEndTimeArgs, TooltipSeriesArray } from '../tooltip-model';
import { findTooltipEndTime } from '../utils';

export interface TimeSeriesTooltipHeaderProps {
  series: TooltipSeriesArray;
  dataset: TimeSeriesDataset[];
  isTooltipPinned: boolean;
  enablePinning?: boolean;
  showEndTime?: ShowEndTimeArgs;
  timeRange?: AbsoluteTimeRange;
  isEventTooltip?: boolean;
  onShowAllClick?: (checked: boolean) => void;
  onUnpinClick?: () => void;
  timeScale?: TimeScale;
}

export const TimeSeriesTooltipHeader = ({
  series,
  dataset,
  enablePinning,
  isTooltipPinned,
  onUnpinClick,
  timeRange,
  showEndTime,
  isEventTooltip,
  timeScale,
}: TimeSeriesTooltipHeaderProps) => {
  let startDate: Date | undefined;
  let endDate: Date | undefined;

  if (isEventTooltip) {
    const eventPayload = series[0]?.event;
    if (eventPayload) {
      startDate = new Date(eventPayload.timestampMs);

      if (eventPayload.endTimestampMs && eventPayload.timestampMs !== eventPayload.endTimestampMs) {
        endDate = new Date(eventPayload.endTimestampMs);
      }
    }
  } else {
    const seriesTimeMs = series[0]?.date ?? null;
    if (seriesTimeMs === null) {
      return null;
    }
    startDate = new Date(seriesTimeMs);

    if (showEndTime && timeRange && dataset && series) {
      const index = series[0]?.dataIndex;
      const datasetValues = dataset[0]?.source;
      if (datasetValues && index !== null && index !== undefined) {
        const endTimeMs = findTooltipEndTime({
          index,
          values: datasetValues,
          timeRange,
          showEndTime,
          timeScale,
        });
        if (endTimeMs) {
          endDate = new Date(endTimeMs);
        }
      }
    }
  }

  return (
    <TooltipHeader
      startDate={startDate}
      endDate={endDate}
      enablePinning={enablePinning}
      isTooltipPinned={isTooltipPinned}
      onUnpinClick={onUnpinClick}
    />
  );
};
